import { render } from "./hotelCard.vue?vue&type=template&id=49321b7f&scoped=true"
import script from "./hotelCard.vue?vue&type=script&lang=js"
export * from "./hotelCard.vue?vue&type=script&lang=js"

import "./hotelCard.vue?vue&type=style&index=0&id=49321b7f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49321b7f"]])

export default __exports__